import React, { useContext, useEffect } from 'react';
import {
	Header,
	Page,
	PageAuth,
	PageHeader,
	PERMISSIONS,
	Sidebar,
	SideMenu,
	PageContainer,
	GlobalAlert,
	Filters,
} from '../..';
import { CASINO_GAME_PARTNERS_SEARCH_TYPES, gamesPages, useStore } from '../../../common';
import { Pagination, Table, Modal, Button } from 'esa-ui-library';
import styles from './GamePartners.module.scss';
import { AuthContext } from '../../../logic';
import { PropertyType } from 'esa-ui-library/lib/types';
import { getRows } from './RowProvider';
import { gamePartnersListMap } from './GamePartners.const';
import { SearchFilter } from '../../components/Filters/components';
import { filterSearchOptionsByEnv } from '../Games/Games.helper';
import { ShowGames } from './components/ShowGames';
import { AssignGamesForm } from './components/AssignGamesForm';
import { PartnerSkinPrefs } from '../Games/components/PartnerSkinPrefs/PartnerSkinPrefs';
import { PartnerGameSettings } from '../Games/components/PartnerGameSettings/PartnerGameSettings';

const GamePartners = (): JSX.Element => {
	const [state, dispatch] = useStore();
	const {
		gamePartners,
		rows,
		bulkRows,
		columns,
		pagesTotal,
		currentPage,
		gamePartnersLoading,
		perPage = '10',
		selectedGamePartner,
		activeGames,
	} = state;
	const { token } = useContext(AuthContext);
	const [showGamesModal, setShowGamesModal] = React.useState(false);
	const [assignGamesModal, setAssignGamesModal] = React.useState(false);
	const [isFormValid, setIsFormValid] = React.useState(false);
	const [loading, setLoading] = React.useState(false);
	const [selectedPartnerForPrefs, setSelectedPartnerForPrefs] = React.useState<{
		id: number;
		name: string;
		partner: string;
	} | null>(null);
	const [selectedPartnerForSettings, setSelectedPartnerForSettings] = React.useState<{
		id: number;
		name: string;
		partner: string;
		gameId: number;
	} | null>(null);

	const filteredGamePartnersFields = gamePartnersListMap;

	const setColumnsConfig = (columns: PropertyType[]) =>
		columns.map((c) => {
			return {
				...c,
				cellClassName: c.position ? styles[c.position] : '',
			};
		});

	const onAction = async (type: string, gamePartner: PropertyType) => {
		switch (type) {
			case 'showGames':
				await dispatch('SELECT_GAME_PARTNER', gamePartner);
				setShowGamesModal(true);
				break;
			case 'assignGames':
				await dispatch('SELECT_GAME_PARTNER', gamePartner);
				setAssignGamesModal(true);
				break;
			default:
				break;
		}
	};

	const onCloseShowGamesModal = () => {
		if (selectedPartnerForPrefs || selectedPartnerForSettings) return;
		setShowGamesModal(false);
		dispatch('SELECT_GAME_PARTNER', null);
	};

	const onCloseAssignGamesModal = () => {
		setAssignGamesModal(false);
		dispatch('SELECT_GAME_PARTNER', null);
	};

	const onSubmitAssignGames = async (action = 'replace') => {
		if (!selectedGamePartner) return;
		setLoading(true);
		const partnerId = selectedGamePartner.skinid;
		await dispatch('ASSIGN_GAMES', {
			token,
			gameIds: activeGames.map((g: any) => g.value),
			partnerId,
			action,
		});
		setLoading(false);
		onCloseAssignGamesModal();
		dispatch('FETCH_PARTNER_GAMES', {
			token,
			partnerId,
		});
	};

	useEffect(() => {
		dispatch('LOADING', false);
		dispatch('GAME_PARTNERS_INIT', { token, currentPage, perPage });
	}, []);

	const onPageChange = (page: number | string) => {
		dispatch('LOADING', true);
		dispatch('PAGE_UPDATE', { token, page, perPage });
	};

	useEffect(() => {
		dispatch('UPDATE_COLUMNS', setColumnsConfig(filteredGamePartnersFields));
	}, [gamePartners, bulkRows]);

	useEffect(() => {
		dispatch('UPDATE_ROWS', getRows(gamePartners, columns, onAction));
	}, [gamePartners, columns]);

	const onPerPageChange = (value: PropertyType) => {
		const perPage = value[0].value;
		dispatch('LOADING', true);
		dispatch('PER_PAGE', perPage);
		dispatch('PAGE_UPDATE', { token, currentPage, perPage });
	};
	return (
		<>
			<Header dataId='header' />
			<PageAuth onlyAdmin permission={PERMISSIONS.canListGames}>
				<PageContainer>
					<Sidebar dataId='admin-sidebar'>
						<SideMenu options={gamesPages} title='Game Partners' />
					</Sidebar>
					<Page>
						<PageHeader title='Casino Game Partners'>
							{/*{user?.permissions?.isSuperAdmin ? (*/}
							{/*	<Button dataId='create-user' primary small onClick={onAddGamePartner}>*/}
							{/*		<PlusLight className={styles.AddUserIcon} />*/}
							{/*		Create Game Partner*/}
							{/*	</Button>*/}
							{/*) : null}*/}
						</PageHeader>
						<section className={styles.PageContent}>
							<Filters>
								<div style={{ marginLeft: 'auto' }}>
									<SearchFilter searchTypes={filterSearchOptionsByEnv(CASINO_GAME_PARTNERS_SEARCH_TYPES)} />
								</div>
							</Filters>
							{(!!gamePartners?.length || gamePartnersLoading) && (
								<>
									<Table
										titles={[...columns, '']}
										data={rows}
										className={styles.GamePartnersTable}
										rowClassName={styles.GamePartnersRow}
										isLoading={gamePartnersLoading}
									/>
									<Pagination
										total={Math.ceil(pagesTotal / +perPage)}
										current={currentPage}
										onChange={onPageChange}
										perPage={perPage}
										showPerPage
										onPerPage={onPerPageChange}
									/>
								</>
							)}
							{/*{editModal && (*/}
							{/*	<Modal*/}
							{/*		title={selectedGamePartner ? 'Edit Game Partner' : 'Create Game Partner'}*/}
							{/*		submitLabel={SAVE}*/}
							{/*		primary*/}
							{/*		onCancel={onCloseCreateModal}*/}
							{/*		onSubmit={onSubmit}*/}
							{/*		loading={loading}*/}
							{/*	>*/}
							{/*		<CreateGamePartnerForm isEdit={!!selectedGamePartner} />*/}
							{/*	</Modal>*/}
							{/*)}*/}
							{showGamesModal && (
								<Modal
									title={`Assigned Games - ${selectedGamePartner?.partner_name}${
										selectedGamePartner?.name ? ` - ${selectedGamePartner?.name}` : ''
									} (${selectedGamePartner?.partnerid} - ${selectedGamePartner?.skinid})`}
									onCancel={onCloseShowGamesModal}
									onSubmit={onCloseShowGamesModal}
									submitLabel='Close'
									primary
								>
									<>
										<ShowGames
											onPrefsClick={setSelectedPartnerForPrefs}
											onSettingsClick={setSelectedPartnerForSettings}
										/>
										{selectedPartnerForPrefs && (
											<PartnerSkinPrefs
												partnerId={selectedPartnerForPrefs.id}
												partnerName={selectedPartnerForPrefs.name}
												partner={selectedPartnerForPrefs.partner}
												onClose={() => setSelectedPartnerForPrefs(null)}
											/>
										)}
										{selectedPartnerForSettings && (
											<PartnerGameSettings
												partnerId={selectedPartnerForSettings.id}
												partnerName={selectedPartnerForSettings.name}
												partner={selectedPartnerForSettings.partner}
												gameId={selectedPartnerForSettings.gameId}
												onClose={() => setSelectedPartnerForSettings(null)}
											/>
										)}
									</>
								</Modal>
							)}
							{assignGamesModal && (
								<Modal
									title={`Assign Games - ${selectedGamePartner?.partner_name}${
										selectedGamePartner?.name ? ` - ${selectedGamePartner?.name}` : ''
									} (${selectedGamePartner?.partnerid})`}
									onCancel={onCloseAssignGamesModal}
									loading={loading}
								>
									<>
										<AssignGamesForm onValidityChange={setIsFormValid} />
										<div className={styles.ModalFooter}>
											<Button primary onClick={() => onSubmitAssignGames('add')} disabled={loading || !isFormValid}>
												Add
											</Button>
											<Button danger onClick={() => onSubmitAssignGames('remove')} disabled={loading || !isFormValid}>
												Remove
											</Button>
											<Button primary onClick={() => onSubmitAssignGames('replace')} disabled={loading || !isFormValid}>
												Replace
											</Button>
											<Button onClick={onCloseAssignGamesModal}>Cancel</Button>
										</div>
									</>
								</Modal>
							)}
						</section>
					</Page>
				</PageContainer>
				<GlobalAlert />
			</PageAuth>
		</>
	);
};

export { GamePartners };
